import { useState } from "react";
import { Lock, Mail, KeyRound, FileText, Upload, Download, Bell, Calendar, Clock, LayoutDashboard } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PageHero, GoldButton } from "@/components/Ui";
import { PRATICA_STATI } from "@/data/content";

const FEATURES = [
  { icon: FileText, t: "Stato pratica", d: "Segui in tempo reale l'avanzamento della tua pratica." },
  { icon: Upload, t: "Carica documenti", d: "Invia PDF e immagini in modo sicuro." },
  { icon: Download, t: "Scarica ricevute", d: "Ricevute, guide e moduli sempre disponibili." },
  { icon: Calendar, t: "Appuntamenti", d: "Consulta e gestisci i tuoi appuntamenti." },
  { icon: Clock, t: "Scadenze", d: "Promemoria personalizzati sulle tue scadenze." },
  { icon: Bell, t: "Notifiche", d: "Ricevi comunicazioni e aggiornamenti." },
];

const AreaAssistiti = () => {
  const [mode, setMode] = useState("login");

  const handle = (e) => { e.preventDefault(); toast.info("L'accesso all'Area Riservata sarà attivo a breve. Contatta una nostra sede per le credenziali."); };

  return (
    <div data-testid="area-assistiti-page">
      <PageHero eyebrow="Area riservata assistiti" title="La tua pratica, sempre con te" subtitle="Accedi con le tue credenziali per gestire documenti, appuntamenti, scadenze e comunicazioni." />

      <section className="bg-[#F8F9FA] py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
          <div className="bg-white border border-gray-100 shadow-crisp p-8 md:p-10">
            <div className="w-14 h-14 bg-navy-900 flex items-center justify-center"><Lock className="w-7 h-7 text-gold-500" /></div>
            <h2 className="mt-6 font-serif text-3xl font-semibold text-navy-900">{mode === "login" ? "Accedi all'area riservata" : "Recupera password"}</h2>

            <form onSubmit={handle} className="mt-8 space-y-5" data-testid="login-form">
              <div><Label htmlFor="l-email">Email</Label>
                <div className="relative mt-2"><Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" /><Input id="l-email" type="email" data-testid="login-email" className="pl-10 rounded-none border-gray-200" placeholder="nome@email.it" /></div>
              </div>
              {mode === "login" && (
                <div><Label htmlFor="l-pass">Password</Label>
                  <div className="relative mt-2"><KeyRound className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" /><Input id="l-pass" type="password" data-testid="login-password" className="pl-10 rounded-none border-gray-200" placeholder="••••••••" /></div>
                </div>
              )}
              <GoldButton type="submit" className="w-full" data-testid="login-submit-btn">{mode === "login" ? "Accedi" : "Invia link di recupero"}</GoldButton>
            </form>

            <div className="mt-6 text-sm text-slate-600">
              {mode === "login" ? (
                <button onClick={() => setMode("recover")} className="hover:text-gold-600 transition-colors" data-testid="forgot-password-link">Hai dimenticato la password?</button>
              ) : (
                <button onClick={() => setMode("login")} className="hover:text-gold-600 transition-colors" data-testid="back-login-link">← Torna al login</button>
              )}
            </div>
          </div>

          <div>
            <h3 className="font-serif text-2xl font-semibold text-navy-900">Cosa puoi fare nell'area riservata</h3>
            <div className="mt-6 grid sm:grid-cols-2 gap-4">
              {FEATURES.map((f, i) => (
                <div key={f.t} data-testid={`area-feature-${i}`} className="bg-white border border-gray-100 shadow-crisp p-5">
                  <f.icon className="w-6 h-6 text-gold-500 mb-3" />
                  <div className="font-serif text-lg font-semibold text-navy-900">{f.t}</div>
                  <p className="text-sm text-slate-600 mt-1">{f.d}</p>
                </div>
              ))}
            </div>

            <h3 className="mt-10 font-serif text-2xl font-semibold text-navy-900 flex items-center gap-2"><LayoutDashboard className="w-5 h-5 text-gold-500" /> Stati delle pratiche</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {PRATICA_STATI.map((s, i) => (
                <span key={s.label} data-testid={`stato-${i}`} className={`px-3 py-1.5 text-xs font-bold uppercase tracking-[0.08em] ${s.color}`}>{s.label}</span>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AreaAssistiti;
